/* eslint-disable */
import Api from '@/api/services/Api'

const route = '/adm-notification'

export default {
    get: params => {
        let customRoute = `${route}?user_id=${params.currentUser}&estado=1&expand=notificationGestor,status_description,status_lectura&search=${params.filter}`
        switch (params.notificacionEstado) {
            case "2": customRoute = `${route}?user_id=${params.currentUser}&estado=1&leida=2&expand=notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?user_id=${params.currentUser}&estado=1&leida=1&expand=notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            case "6": customRoute = `${route}?user_id=${params.currentUser}&${params.customfilter}&estado=1&expand=notificationGestor,status_description,status_lectura&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    put: payload => Api().put(`${route}/${payload.id}?expand=notificationGestor,status_description,status_lectura`, payload),
    getUnreadNotificaciones: params => Api().get(`${route}?user_id=${params.currentUser.id}&estado=1&leida=2&expand=notificationGestor`, { crossDomain: true }),
}
